export const NEW_INVITATION_ERRORS: { [key: string]: string } = {
  UNAUTHORIZED: '+NEW_INVITATION.ERROR.UNAUTHORIZED',
  VALIDATION_ERROR: '+NEW_INVITATION.ERROR.VALIDATION_ERROR',
  INVITEE_NOT_EXISTS: '+NEW_INVITATION.ERROR.INVITEE_NOT_EXISTS',
  INVALID_INVITEE: '+NEW_INVITATION.ERROR.INVALID_INVITEE',
  ACCESS_ALREADY_GRANTED: '+NEW_INVITATION.ERROR.ACCESS_ALREADY_GRANTED',
  NOT_FOUND: '+NEW_INVITATION.ERROR.NOT_FOUND',
  PENDING_INVITATION_EXISTS: '+NEW_INVITATION.ERROR.PENDING_INVITATION_EXISTS',
  MAINTAINER_ALREADY_ASSIGNED: '+NEW_INVITATION.ERROR.MAINTAINER_ALREADY_ASSIGNED',
  OTHER: '+NEW_INVITATION.ERROR.OTHER',
  NOT_ALLOWED: '+NEW_INVITATION.ERROR.NOT_ALLOWED',
  UNSUPPORTED_METHOD: '+NEW_INVITATION.ERROR.NOT_ALLOWED',
};
